<!-- /oauth/<provider>

This page helps with oauth flows.

It should be opened in a window. Then it will call a function `onOauth`
on the window opener and close itself.

-->
<template>
  <div/>
</template>
<script>
export default {
  props: ['providerRedirect'],
  mounted() {
    window.opener.onOauth(this.providerRedirect, this.$route.query);
    window.close();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/oauth.vue